import { useStaffGetCommissionInfoForCampaign } from '@urbanx/agx.campaigns.client'
import {
  AgxButton,
  AgxColumn,
  AgxCommissionTableView,
  AgxRow,
  AgxTypography,
  Icon_EditOutline,
} from '@urbanx/agx.ui-components2'
import Panel from 'components/panel/Panel'
import { CommissionMenu, FinanceMenu, MenuTitles } from 'constants/menu'
import { useSelectedCampaign } from 'hooks'
import { ContentLayout } from 'layout'
import CommissionHistoryModal from './CommissionHistoryModal'
import { useState } from 'react'
import EditCommissionModal from './EditCommissionModal'
const CommissionPage = () => {
  const { campaign: selectedCampaign } = useSelectedCampaign()

  const {
    data: commissionInformation,
    isPending: commissionInformationPending,
  } = useStaffGetCommissionInfoForCampaign(
    selectedCampaign?.campaignId || '',
    !!selectedCampaign
  )

  const currentCommissionInfo =
    commissionInformation?.commissionInformation?.currentCommissionDetails
      ?.commissionDetails

  const [isCommissionHistoryModalOpen, setIsCommissionHistoryModalOpen] =
    useState(false)

  const [isEditCommissionModalOpen, setIsEditCommissionModalOpen] =
    useState(false)

  return (
    <>
      <ContentLayout
        hasSecondaryMenu={false}
        secondaryActiveMenu={MenuTitles.COMMISSION}
        secondaryMenuOverride={FinanceMenu}
        isCampaigns={true}
        tertiaryMenu={CommissionMenu}
        tertiaryActiveMenu={MenuTitles.COMMISSION_COMMISSION}
        tertiaryTitle={'Commission'}
      >
        {isCommissionHistoryModalOpen && (
          <CommissionHistoryModal
            onClose={() => setIsCommissionHistoryModalOpen(false)}
            commission={commissionInformation?.commissionInformation}
          />
        )}

        {isEditCommissionModalOpen && (
          <EditCommissionModal
            onClose={() => setIsEditCommissionModalOpen(false)}
            currentCommissionDetails={currentCommissionInfo!}
          />
        )}

        <Panel
          title={
            <AgxTypography id="panel" type="title" size="large">
              Commission
            </AgxTypography>
          }
          padding={{
            top: 'spacing-3xl',
            bottom: 'spacing-3xl',
            left: 'spacing-5xl',
            right: 'spacing-5xl',
          }}
        >
          <AgxColumn gap="spacing-3xl" fill>
            {!commissionInformationPending && (
              <>
                {currentCommissionInfo !== undefined && (
                  <AgxCommissionTableView
                    currentCommissionDetails={currentCommissionInfo}
                  />
                )}
                <AgxRow
                  gap="spacing-xl"
                  fill
                  alignItems="alignCenter"
                  justifyContent="right"
                >
                  {currentCommissionInfo !== undefined && (
                    <AgxButton
                      id={'viewCommissionHistory'}
                      text={'View history'}
                      variant={'hollow'}
                      size="small"
                      onClick={() => setIsCommissionHistoryModalOpen(true)}
                    />
                  )}
                  <AgxButton
                    id={'editCommission'}
                    text={'Edit'}
                    variant={'hollow'}
                    size="small"
                    rightIcon={
                      <Icon_EditOutline color="var(--fg-brand-accent)" />
                    }
                    onClick={() => setIsEditCommissionModalOpen(true)}
                  />
                </AgxRow>
              </>
            )}
          </AgxColumn>
        </Panel>
      </ContentLayout>
    </>
  )
}

export default CommissionPage
